import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectCurrentagency,
  selectCurrentToken,
} from "../../redux/features/authSlice";

export default function FacebookConnectPage() {
  const location = useLocation();

  // ✅ Use useMemo so query doesn't change on every render
  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const [pages, setPages] = useState([]);
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [agencyId, setAgencyId] = useState(null);
  const [fbToken, setFbToken] = useState("");

  const currentAgency = useSelector(selectCurrentagency);
  const token = useSelector(selectCurrentToken);

  useEffect(() => {
    const urlAgencyId = query.get("agencyId");
    const longToken = query.get("token");
    const pagesData = query.get("pages");

    // ✅ Handle Facebook redirect
    if (urlAgencyId && longToken && pagesData) {
      setConnected(true);
      setAgencyId(urlAgencyId);
      setFbToken(longToken);

      try {
        const decodedPages = JSON.parse(decodeURIComponent(pagesData));
        setPages(decodedPages?.data || []);
      } catch (e) {
        console.error("Error parsing pages data:", e);
        setPages([]);
      }
    } else if (currentAgency?.agencyid) {
      // Fallback when opened directly
      setAgencyId(currentAgency.agencyid);
    }

    setLoading(false);
  }, [query, currentAgency?.agencyid]);


  const handleRegisterPages = async () => {
    console.log(pages)
    if (!agencyId || !fbToken || pages.length === 0) {
      alert("No pages or token found to register.");
      return;
    }

    try {
      const res = await fetch(
        "https://data.realtorscrm.com/api/facebooknew/register-pages",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            agencyid: agencyId,
            token: fbToken,
            selectedPages: pages,
          }),
        }
      );

      if (res.ok) {
        alert("✅ Facebook pages registered successfully!");
      } else {
        alert("❌ Failed to register pages.");
      }
    } catch (err) {
      console.error("Error registering pages:", err);
      alert("Error registering pages.");
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: "auto" }}>
      {connected && (
        <Paper sx={{ p: 3, mt: 3 }} elevation={3}>
          <Typography variant="h4" gutterBottom>
            Facebook Integration
          </Typography>
          <Typography variant="h6" gutterBottom color="success.main">
            Facebook Connected Successfully!
          </Typography>

          <Typography variant="body1" gutterBottom>
            Agency ID: {agencyId}
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle1" fontWeight="bold">
            Connected Pages
          </Typography>

          <List>
            {pages.length > 0 ? (
              pages.map((p) => (
                <ListItem key={p.id}>
                  <ListItemText
                    primary={p.name}
                    secondary={`Page ID: ${p.id}`}
                  />
                </ListItem>
              ))
            ) : (
              <ListItem>
                <ListItemText primary="No pages found." />
              </ListItem>
            )}
          </List>

          <Divider sx={{ my: 2 }} />

          <Button
            variant="contained"
            color="primary"
            onClick={handleRegisterPages}
          >
            Register Pages
          </Button>
        </Paper>
      )}
    </Box>
  );
}
